<div class="editor-label">
  @if (label()) { {{ label() }} }
  <div #host class="editor-host"></div>
</div>
